import { render, staticRenderFns } from "./NomurakougeiView.vue?vue&type=template&id=545ea3a1&scoped=true&"
import script from "./NomurakougeiView.vue?vue&type=script&lang=js&"
export * from "./NomurakougeiView.vue?vue&type=script&lang=js&"
import style0 from "./NomurakougeiView.vue?vue&type=style&index=0&id=545ea3a1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545ea3a1",
  null
  
)

export default component.exports